export default __webpack_public_path__ + "static/media/medion_seo_image.64dc43fa.jpg";